import React from 'react';
interface LogoProps {
  variant?: 'light' | 'dark';
  showTagline?: boolean;
}
function InterlockMark({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 48 60" className={className} fill="currentColor" aria-hidden="true" data-id="element-313" data-mp="8v67f48754bx">
      <polygon points="6,56 6,40 22,24 22,40" data-id="element-314" data-mp="3v8nxvvv242j9" />
      <polygon points="26,56 26,32 42,8 42,32" data-id="element-315" data-mp="3v9fu98wha4al" />
    </svg>;
}
export function Logo({
  variant = 'light',
  showTagline = false
}: LogoProps) {
  const isDark = variant === 'dark';
  return <div className="flex flex-col gap-2" data-id="element-316" data-mp="rqwa6tnye4qv">
      <div className="flex items-center gap-2.5" data-id="element-317" data-mp="rpl60sqliuz8">
        <InterlockMark className={`w-[16px] h-[20px] flex-shrink-0 ${isDark ? 'text-arena' : 'text-verde'}`} data-id="element-318" data-mp="dr4os7v3xm2u" />
        <span className={`font-display font-semibold text-[19px] md:text-[20px] tracking-[-0.01em] ${isDark ? 'text-arena' : 'text-carbon'}`} data-id="element-319" data-mp="hrycp18jv0vq">
          ORIGEN
        </span>
      </div>
      {showTagline && <span className={`font-body text-[10px] uppercase tracking-[0.14em] leading-[1.5] ${isDark ? 'text-arena/50' : 'text-carbon/45'}`} data-id="element-320" data-mp="1ev01tu3zlwwn">
          Sistemas digitales para
          <br data-id="element-321" data-mp="19y9huvp2ah5y" />
          empresas que quieren crecer
        </span>}
    </div>;
}